import { axiosRequest } from '../../utils/Requests.js';
import { latLng, icon } from 'leaflet';
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'

export default {
    components: {
      LMap,
      LTileLayer,
      LMarker
    },
    props: [ 'imobiliaria' ],
    data() {
      return {
        mensagem: {
          cliente: "",
          telefone: "",
          email: "",
          texto: ""
        },
        showToast: false,
        toastTitle: "",
        toastVariant: "",
        toastMessage: "",

        urlMapa: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attributionMapa: '&copy; <a href="http:osm.org/copyright">OpenStreetMap</a> contributors',
        center: latLng(-5.0673272, -42.8014819),
        zoom: 14,
        icon: icon({
          iconUrl: require("../../../assets/imagens/mapIconRed.png"),
          iconSize: [32,37],
          iconAnchor: [16,37]
        }),
      }
    },
    computed: {
      isVisibleConteudoPersonalizado() {
        return this.imobiliaria.parametros.tituloFaleConosco
          && this.imobiliaria.parametros.tituloFaleConosco.trim()
          && this.imobiliaria.parametros.descricaoFaleConosco
          && this.imobiliaria.parametros.descricaoFaleConosco.trim();
      },
      isVisibleMapa() {
        return this.imobiliaria.urlMapaEstatico !== null;
      },


      centroMapa() { 
        if(this.imobiliaria.latitude || this.imobiliaria.longitude) {
          return latLng(this.imobiliaria.latitude, this.imobiliaria.longitude); 
        } else {
          return latLng(-5.0660888, -42.8042637);
        }
      },
    },
    mounted() {
      document.title = "Fale Conosco | " + this.imobiliaria.nome
    },
    methods: {
      validarForm() {
        if((this.mensagem.cliente !== null && this.mensagem.cliente !== '' ) && 
          ((this.mensagem.telefone !== null && this.mensagem.telefone !== '') || (this.mensagem.email !== null && this.mensagem.email !== '')) && 
        (this.mensagem.texto !== null && this.mensagem.texto !== '')) {
          return true;
        } else {
          return false;
        }
      },

      enviarMensagem() {
        if(this.validarForm()) {
          axiosRequest.post("/enviarMensagem", this.mensagem)
          .then((resultado) => {
            this.mensagem.cliente = "";
            this.mensagem.telefone = "";
            this.mensagem.email = "";
            this.mensagem.texto = "";
            this.setData(resultado.data)

            this.showToast = true;
            this.toastTitle = "Sucesso";
            this.toastVariant = "success";
            this.toastMessage = "Sua mensagem foi enviada com sucesso!";
          }).catch(() => {
            this.pagina += 1
            this.loadingImoveis = false;
            this.showToast = true;
            this.toastTitle = "Falha";
            this.toastVariant = "warning";
            this.toastMessage = "Sua mensagem não foi enviada!";
          });
        } else {
          return;
        }
      }
    }
}
